import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators'
import { FollowersAction } from './followers.actions';
import { Injectable } from '@angular/core';

import { EMPTY, map, switchMap, catchError } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectFollowers, selectFollowings } from './followers.selectors';
import { FollowApi } from '../../api/follow.api';

const DEFAULT_PAGE_SIZE = 15;
@Injectable()
export class FollowersEffects {
  getFollowers$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FollowersAction.getFollowers),
      concatLatestFrom(({ userId }) => this.store.select(selectFollowers({userId}))),
      switchMap(( [{ userId, page }]) => {
        if (!userId || userId === 'me') {
          return this.followApi.getMyFollowers(page, DEFAULT_PAGE_SIZE).pipe(
            map((body) => ({type: '[Followers] Followers loaded', userId: 'me', body, page, pageSize: DEFAULT_PAGE_SIZE})),
            catchError(() => {
              console.error('Unable to load user followers');
              return EMPTY;
            })
          );
        }

        return this.followApi.getFollowers(page, DEFAULT_PAGE_SIZE, +userId).pipe(
          map((body) => ({type: '[Followers] Followers loaded', userId, body, page, pageSize: DEFAULT_PAGE_SIZE})),
          catchError(() => {
            console.error(`Unable to load followers for user ${userId}`);
            return EMPTY;
          })
        );
      })
    );
  }, {
    dispatch: true,
  });

  getFollowings$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FollowersAction.getFollowings),
      concatLatestFrom(({ userId }) => this.store.select(selectFollowings({userId}))),
      switchMap(( [{ userId, page }]) => {

        if (!userId || userId === 'me') {
          return this.followApi.getMyFollowings(page, DEFAULT_PAGE_SIZE).pipe(
            map((body) => ({type: '[Followers] Followings loaded', userId: 'me', body, page, pageSize: DEFAULT_PAGE_SIZE})),
            catchError(() => {
              console.error('Unable to load user followers');
              return EMPTY;
            })
          );
        }

        return this.followApi.getFollowings(page, DEFAULT_PAGE_SIZE, +userId).pipe(
          map((body) => ({type: '[Followers] Followings loaded', userId, body, page, pageSize: DEFAULT_PAGE_SIZE})),
          catchError(() => {
            console.error(`Unable to load followers for user ${userId}`);
            return EMPTY;
          })
        );
      })
    );
  }, {
    dispatch: true,
  });

  constructor(
    private readonly actions$: Actions,
    private readonly store: Store,
    private readonly followApi: FollowApi
    ) {}
}
